export default "__VITE_ASSET__CUx7ktCc__"